module.exports = __webpack_public_path__ + "assets/review.6b3a5d9f.svg";